import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  topText: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: 16,
    lineHeight: "22px",
    color: "#465869",
    width: "100%",
  },
  uploadText: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 16,
    lineHeight: "24px",
    color: "#308CDB !important",
  },
  bottomText: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "19px",
    color: "#465869",
  },
  dueText: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "21px",
    color: "#465869",
  },
  notDefined: {
    color: "#9CA6AF",
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "19px",
  },
  bottom: {
    width: "100%",
    marginTop: "17px",
  },
  button: {
    height: "32px",
    padding: "8px 20px",
    fontSize: "13px",
    fontFamily: "Inter",
  },
  uploadButton: {
    fontWeight: 700,
    lineHeight: "17px",
  },
  uploadingButton: {
    backgroundColor: "#F2F4F7",
    color: "#308CDB !important",
    pointerEvents: "none",
  },
  uploadedText: {
    color: "#308CDB !important",
    marginLeft: "8px !important",
  },
  generatedText: {
    color: "#32D583 !important",
    marginLeft: "8px !important",
  },
  uploadTooltip: {
    display: "flex !important",
    marginLeft: "8px !important",
    alignSelf: "flex-start !important",
  },
  colorBlue: {
    color: "#308CDB !important",
  },
  colorRed: {
    color: "#F97066 !important",
  },
  colorGreen: {
    color: "#32D583 !important",
  },
  container: {
    borderRadius: "8px",
    background: "#F8FAFC",
    padding: "12px 16px !important",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
  },
  input: {
    display: "none",
  },
  loading: {
    color: "#308CDB",
    marginRight: "12px",
  },
}));

export default styles;
